<template>
  <div class="audio-player">
    <div class="audio-player__content">
      <div class="img_wrapper">
        <div v-if="isLoading" class="loader-wrap">
          <div class="loader">
            <span class="loader-item"></span>
            <span class="loader-item"></span>
            <span class="loader-item"></span>
            <span class="loader-item"></span>
            <span class="loader-item"></span>
            <span class="loader-item"></span>
            <span class="loader-item"></span>
            <span class="loader-item"></span>
            <span class="loader-item"></span>
            <span class="loader-item"></span>
          </div>
        </div>
        <img :src="img" @click.stop="playPauseAudio">
      </div>
      <div class="audio-player__progress_bar" :style="{width: currentProgressBar + '%'}"></div>
      <div class="audio-player__currentTimeContainer">
        <span class="audio-player__currentTime">{{ currentTime | fancyTimeFormat }}</span>
        <span class="audio-player__totalTime">{{ duration | fancyTimeFormat }}</span>
      </div>

      <audio
        ref="audioElement"
        class="mediaplayer-controls"
        controls="controls"
        controlslist="nodownload"
        autoplay="true"
        :src="audioSource"
      >Your browser does not support the audio element.</audio>
    </div>
  </div>
</template>

<script>
// Based on the VueJS AudioPlayerV2 by Shameem A.R.
export default {
  name: "AudioPlayer",
  data() {
    return {
      isLoading: true,
      audioElement: "",
      audioSource: "",
      currentProgressBar: 0,
      currentTime: 0,
      duration: 0
    };
  },
  props: {
    src: {
      type: String
    },
    img: {
      type: String
    }
  },
  filters: {
    fancyTimeFormat: function(s) {
      s = Math.round(s);
      return (s - (s %= 60)) / 60 + (9 < s ? ":" : ":0") + s;
    }
  },
  watch: {
    audioSource: function(newVal, oldVal) {
      //console.log("audioSource changed: ['" + oldVal + "' : '" + newVal + "']");
      //console.log("isPaused: " + this.audioElement.paused);
      this.audioElement.src = newVal;
      this.getAudio();
    }
  },
  mounted: function() {
    //this.audioElement = document.getElementById("ap");
    this.audioElement = this.$refs.audioElement;
    this.audioSource = this.src;
    this.audioElement.loop = false;
  },
  methods: {
    getAudio: function() {
      this.audioElement.addEventListener("timeupdate", this.timeUpdate, false);
      this.audioElement.addEventListener("canplaythrough", this.canPlay, false);
      this.audioElement.addEventListener("onended", this.hasEnded, false);
      this.audioElement.load();
    },
    fakeAudio: function(event) {
      this.audioSource = "";
      this.audioElement.load();
    },
    playPauseAudio: function(event) {
      if (this.audioElement.paused) {
        //console.log("Is paused. Now playing " + this.audioSource);
        this.audioElement.volume = 1;
        this.audioElement.play();
      } else {
        //console.log("Is not paused. Pausing...");
        this.audioElement.volume = 0;
        this.audioElement.pause();
      }
    },
    canPlay: function(event) {
      this.duration = this.audioElement.duration;
      this.isLoading = false;
      if (this.audioElement.paused) {
        this.playPauseAudio();
      }
    },
    hasEnded: function(event) {
      this.currentProgressBar = 0;
    },
    timeUpdate: function(event) {
      this.currentTime = this.audioElement.currentTime;
      let playPercent = 100 * (this.audioElement.currentTime / this.duration);
      this.currentProgressBar = playPercent;
    }
  },
  beforeDestroy: function() {
    if (this.audioElement) {
      this.audioElement.removeEventListener("timeupdate", this.timeUpdate);
      this.audioElement.removeEventListener("canplaythrough", this.canPlay);
      this.audioElement.removeEventListener("onended", this.hasEnded);
      this.audioElement.volume = 0;
      this.fakeAudio();
    }
  }
};
</script>